import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faImages } from "@fortawesome/free-solid-svg-icons"

export const Images = (props) => {
  return <FontAwesomeIcon faIcon={faImages} {...props} />
}
